import { Component } from "@angular/core";

@Component({
  selector: "not-found-page",
  template: `
    <div>
      <h1>404</h1>
      <h2>The page which you are looking for was not found on this server. </h2>
    </div>
  `
})
export class NotFoundPageComponent {}
